import { useUnit } from 'effector-react';
import { ArrowLeft, SearchX } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  $detail,
  $detailFailed,
  detailRequested,
  loadDetailFx,
  positionSelected,
} from '../../entities/position';
import { routes } from '../../shared/routing';
import { Button, EmptyState, Spinner } from '../../shared/ui';
import { AppShell } from '../../widgets/app-shell';
import { PositionDetail } from '../../widgets/position-detail';

export function PositionPage() {
  const { t } = useTranslation();
  const [params, detail, failed, pending, request, select] = useUnit([
    routes.position.$params,
    $detail,
    $detailFailed,
    loadDetailFx.pending,
    detailRequested,
    positionSelected,
  ]);
  const id = Number(params.id);
  useEffect(() => {
    if (Number.isInteger(id)) {
      select(id);
      request(id);
    }
  }, [id, request, select]);

  const current = detail?.id === id ? detail : null;
  return (
    <AppShell
      page="positions"
      crumbs={[
        t('nav.positions'),
        current ? `${current.instrument.display_symbol} #${String(current.id)}` : `#${params.id}`,
      ]}
    >
      <div className="mx-auto w-full max-w-3xl px-2 py-4 max-sm:px-0">
        <Button
          variant="ghost"
          size="sm"
          leadingIcon={<ArrowLeft />}
          className="mb-2 ml-2"
          onClick={() => {
            void routes.positions.open();
          }}
        >
          {t('nav.positions')}
        </Button>
        {current ? (
          <div className="rounded-lg border border-border-subtle bg-bg-1">
            <PositionDetail detail={current} />
          </div>
        ) : pending ? (
          <div className="flex justify-center py-16">
            <Spinner label={t('common.loading')} />
          </div>
        ) : failed ? (
          <EmptyState className="py-16" icon={<SearchX />} title={t('position.notFound')} />
        ) : null}
      </div>
    </AppShell>
  );
}
